import { css } from 'styled-components';

export function applyCSSOverrides(
  overrides: Record<string, string | number> = {},
) {
  return (
    overrides &&
    css`
      ${Object.entries(overrides)
        .map(([key, value]) => `${key}: ${value};`)
        .join('\n')}
    `
  );
}

export function forIPad(content: string): string {
  return `@media only screen and (max-width: 1200px) {
    ${content}
  }`;
}
